export default __webpack_public_path__ + "static/media/visitfactory.ad60222c.jpg";